/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface PhoneInfoVO {
  /**
   * phone area code
   */
  areaCode?: string;
  /**
   * phone country code
   */
  countryCode?: string;
  deviceType?: PhoneInfoVO.DeviceTypeEnum;
  /**
   * extension
   */
  extension?: string;
  /**
   * id from database
   */
  id?: string;
  isPrimary?: boolean;
  location?: PhoneInfoVO.LocationEnum;
  /**
   * phone number
   */
  phoneNumber?: string;
}
export namespace PhoneInfoVO {
  export type DeviceTypeEnum = 'V' | 'C' | 'P' | 'F' | 'T';
  export const DeviceTypeEnum = {
    V: 'V' as DeviceTypeEnum,
    C: 'C' as DeviceTypeEnum,
    P: 'P' as DeviceTypeEnum,
    F: 'F' as DeviceTypeEnum,
    T: 'T' as DeviceTypeEnum
  };
  export type LocationEnum = 'H' | 'B' | 'O';
  export const LocationEnum = {
    H: 'H' as LocationEnum,
    B: 'B' as LocationEnum,
    O: 'O' as LocationEnum
  };
}
